export enum userRoles {
  Admin = 'Admin',
  Manager = 'Manager',
  Operator = 'Operator',
}
